import type { GetApiV1RefundsEligibilityOrderId401ErrorDetails } from './getApiV1RefundsEligibilityOrderId401ErrorDetails';

/**
 * 에러 응답 형식
 */
export type GetApiV1RefundsEligibilityOrderId401 = {
  /** 에러 코드 */
  errorCode?: string;
  /**
   * 상세 에러 정보
   * @nullable
   */
  errorDetails?: GetApiV1RefundsEligibilityOrderId401ErrorDetails;
  /** 에러 메시지 */
  message: string;
  /** 요청 성공 여부 */
  success: boolean;
  /** 에러 발생 시간 */
  timestamp?: string;
};
